import { StripeChargeModel } from '@modules/stripe/stripe-charge/stripe-charge-model';

const { fields } = StripeChargeModel;

export default [
  fields.id,
  fields.createdAt
];
